import React, { useState, useEffect } from "react";
import axios from "axios";
import CountUp from "react-countup";
// react plugin for creating charts

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons

import MoodIcon from "@material-ui/icons/Mood";
import WarningIcon from "@material-ui/icons/Warning";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import Danger from "components/Typography/Danger.js";
import Warning from "components/Typography/Warning.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Success from "components/Typography/Success";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import Info from "components/Typography/Info.js";
import Footer from "components/Footer/Footer";
const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  const [states, setStates] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [confirmed, setConfirmed] = useState(0);
  const [active, setActive] = useState(0);
  const [recoveries, setRecoveries] = useState(0);
  const [deaths, setDeaths] = useState(0);
  const [deltas, setDeltas] = useState(0);

  useEffect(() => {
    if (fetched === false) {
      getStates();
    }
  }, [fetched]);

  const getStates = async () => {
    try {
      const [response] = await Promise.all([
        axios.get("https://api.covid19india.org/data.json")
      ]);
      setStates(response.data.statewise);
      setFetched(true);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const parseData = () => {
      let confirmed = 0;
      let active = 0;
      let recoveries = 0;
      let deaths = 0;
      let deltas = {};
      states.forEach((state, index) => {
        if (index !== 0) {
          confirmed += parseInt(state.confirmed);
          active += parseInt(state.active);
          recoveries += parseInt(state.recovered);
          deaths += parseInt(state.deaths);
        } else {
          deltas = {
            confirmed: parseInt(state.deltaconfirmed),
            deaths: parseInt(state.deltadeaths),
            recovered: parseInt(state.deltarecovered)
          };
        }
      });
      setConfirmed(confirmed);
      setActive(active);
      setRecoveries(recoveries);
      setDeaths(deaths);
      setDeltas(deltas);
    };
    parseData();
  }, [states]);
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Icon>
                  <WarningIcon />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Confirmed</p>
              <h3 className={classes.cardTitle}>
                <CountUp start={0} end={confirmed} duration={1} separator="," />
                <small></small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Danger>
                  New Cases Today :
                  {deltas
                    ? deltas.confirmed >= 0
                      ? "" + deltas.confirmed
                      : "+0"
                    : ""}
                </Danger>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>
                  <AccessibilityIcon />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Active</p>
              <h3 className={classes.cardTitle}>
                <CountUp start={0} end={active} duration={1} separator="," />
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Info>Active Cases</Info>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Icon>
                  <MoodIcon />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Recovered</p>
              <h3 className={classes.cardTitle}>
                <CountUp
                  start={0}
                  end={recoveries}
                  duration={1}
                  separator=","
                />
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Success>
                  Recovered Today :
                  {deltas
                    ? deltas.recovered >= 0
                      ? "" + deltas.recovered
                      : "+0"
                    : ""}
                </Success>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>
                  <WarningIcon />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Deceased</p>
              <h3 className={classes.cardTitle}>
                <CountUp start={0} end={deaths} duration={1} separator="," />
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Warning>
                  New Deaths Today :
                  {deltas
                    ? deltas.deaths >= 0
                      ? "" + deltas.deaths
                      : "+0"
                    : ""}
                </Warning>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Footer></Footer>
    </div>
  );
}
